import { render, staticRenderFns } from "./room_mgt.vue?vue&type=template&id=b85aff86&scoped=true"
import script from "./room_mgt.vue?vue&type=script&lang=js"
export * from "./room_mgt.vue?vue&type=script&lang=js"
import style0 from "./room_mgt.vue?vue&type=style&index=0&id=b85aff86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85aff86",
  null
  
)

export default component.exports